module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-D15-clean-b7e4772011338751ad86bb6141d202ea.png";